module.exports = __webpack_public_path__ + "img/castSP2x.a24321c4.png";